/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import Reward from 'components/shared/reward/reward';
import GiftCard from 'components/shared/reward/giftcard/giftcard_container';
// utils
import { trackEvent } from 'utils/tracking/tracking';
import { refreshAds } from 'utils/ads';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import RedeemScreen from 'components/screens/redeem/redeem_container';
import styles from 'components/shared/rewardsindicator/rewardsindicator_styles';
import { createStyles } from 'utils/styles';
import { log } from 'utils/logger';
const sheet = createStyles(styles, {link:true});



/* ========== ~~~~~~~~~~ REWARDS INDICATOR : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class RewardsIndicator extends Component {
	constructor(props) {
		super(props);
		this.state = {
			newRewardAvailable: props.numberOfRewardsEarned > 0,
			pointsAwarded: null
		};
		// Styles of this component depend on whether or not the rewards are enabled/permitted for the embed.
		// Sets initial values based off the rewards settings and status.
        sheet.update(props.rewardsEnabled && props.rewardsPermitted)
    }
	componentWillReceiveProps(nextProps) {
		const rewardsUpdateStatus = this.newRewardAvailable(nextProps);
		if (rewardsUpdateStatus) {
			this.setState({ newRewardAvailable: rewardsUpdateStatus });
		}
		if (this.userAwardedPoints(nextProps)) {
			// if user received new points, animate the bar
			this.setState({ pointsAwarded: true });
			// now remove previous state so we can animate again
			setTimeout(() => {
				this.setState({ pointsAwarded: false });
			}, 300);
		}
		this.adjustStylesForRewards(nextProps)
	}
	userAwardedPoints = nextProps => {
		return this.props.pointsEarned !== nextProps.pointsEarned;
	};
    adjustStylesForRewards = nextProps => {
        if (this.props.rewardsEnabled && this.props.rewardsPermitted !== nextProps.rewardsPermitted) {
            sheet.update(nextProps.rewardsPermitted)
        }
    };
	percentageChanged = () => {
		// When user gets enough points to claim a reward we show fully filled points indicator till user closes the redeem screen
		if(this.props.rewardEarnedPhase && this.props.pointsEarned >= this.props.redeemAfter) { return 100; }
		// Calculates percentage to fill points indicator
        const pointsEarnedAfterReward = this.props.pointsEarned - this.props.numberOfRewardsEarned * this.props.redeemAfter;
        return Math.round(100 * pointsEarnedAfterReward / this.props.redeemAfter);
	};
	newRewardAvailable = nextProps => {
		const currentNumberOfRewardsEarned = this.props.numberOfRewardsEarned;
        const nextNumberOfRewardsEarned = nextProps.numberOfRewardsEarned;
        return currentNumberOfRewardsEarned !== nextNumberOfRewardsEarned ? currentNumberOfRewardsEarned === 0 ? 'initial' : 'updated' : false;
	};
    processGiftCardClick = () => {
        this.props.displayScreen({
            name: 'redeem',
            type: 'full',
            visible: true,
            content: <RedeemScreen contentId={this.props.contentId} />
        })
    };
	applyInlineStyles = () => {
		return { width: `${this.percentageChanged()}%` };
	};
	handleLegalClick = e => {
		e.preventDefault();
    // This functionality is deprecated
		// trackEvent({ type: 'click', name: 'linkSelected', additionalProps: {text: e.target.textContent, target:'https://amazon.com/gc-legal'}});
        refreshAds();
		window.open('https://amazon.com/gc-legal');
	};
	render() {
		const pointsEarned = this.props.pointsEarned;
        const pointsEarnedAfterReward = this.props.pointsEarned - this.props.numberOfRewardsEarned * this.props.redeemAfter;
		// If user just earned a reward show that she needs to earn 0 more points to redeem a reward.
        const pointsToEarn = this.props.rewardEarnedPhase ? 0 : this.props.redeemAfter - pointsEarnedAfterReward;
		log('userGeo', this.props.userGeo);
        const gitftCardType = this.props.userGeo === 'US' ? 'amazon' : 'generic';
        const giftCardName = this.props.userGeo === 'US' ? 'Amazon' : '';
        return (
	        <div className={`${sheet.classes.rewardsindicator} rewardsindicator show-${!this.props.showExpandedMessage} rewardAvailable-${this.state.newRewardAvailable}`}>
	        	<div className={`group`}>
	        		<div className={`pointstatus`}>
		        		<div className={`pointstatustext`}>
		        			<span className={`pointsearned`}>{`You have ${pointsEarned} point${pointsEarned === 1 ? '' : 's'}`}</span>
		        		</div>
		        		<div className={`pointstatusbar pointsAwarded-${this.state.pointsAwarded}`}>
		        			<div className={`bar foreground`} style={this.applyInlineStyles()}/>
		        			<div className={`bar background`}/>
		        		</div>
		        		<div className={`pointstatusmessage`}>
		        			Earn <span className={`pointstoredeem`}>{`${pointsToEarn} more ${`point${pointsToEarn === 1 ? '' : 's'}`}`}</span>{` to receive a `}<span className={`reward`}>{`${this.props.monetaryValue} ${giftCardName} gift card.`}</span>
		        		</div>
		        	</div>
	        	</div>
	        	<div className={`group`}>
	        		<Reward numOfRewards={this.props.numberOfRewardsEarned} newRewardAvailable={this.state.newRewardAvailable}>
	        			<GiftCard contentId={this.props.contentId} type={gitftCardType} rewardAvailable={!this.props.rewardEarnedPhase && this.props.numberOfRewardsEarned > 0} processClick={this.processGiftCardClick} numOfRewards={this.props.numberOfRewardsEarned} />
	        		</Reward>
	        		<div className={`disclaimer ${gitftCardType}`}>Restrictions apply, see <a href={``} onClick={this.handleLegalClick}>amazon.com/gc-legal</a></div>
	        	</div>
	        </div>
		);
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default RewardsIndicator;
